export default __webpack_public_path__ + "static/media/minimize.36a60094.svg";